import { BaseApiClient } from './BaseApiClient';
import { IApiInterface } from './IApiConfig';
import { IAuthTokenBuilder } from './IAuthTokenBuilder';

export class BootstrapClient extends BaseApiClient {
  private logger: any;

  public constructor(config: IApiInterface, fetch: any, logger: any, authTokenBuilder: IAuthTokenBuilder) {
    super(config, fetch, authTokenBuilder);
    this.logger = logger || (() => { /* no-op */ });
  }

  public async getDetails(): Promise<any|null> {
    try {
      const request = await this.buildGetRequest('api/');
      const result = await this.fetch(request.url, request.options);
      const response = await this.assertHttp200AndGetJsonFromResult(result);
      this.logger('[BootstrapClient] getDetails', response);
      return response;
    } catch (err) {
      this.logger('[BootstrapClient] failed', err);
      return null;
    }
  }
}
